export const providerTypes = {
	IMX: 'imx',
	ETHEREUM: 'eth',
};

export const providerList = [providerTypes.IMX, providerTypes.ETHEREUM];
